import { Label } from '../../../Label'

import * as styles from './ProfileLabelsWidgetItem.module.css'

function ProfileLabelsWidgetItem({
  className = styles.ProfileLabelsWidgetItem,
  ...restProps
}) {
  return (
    <div className={className}>
      <Label {...restProps} />
    </div>
  )
}

export default ProfileLabelsWidgetItem
